<section class="select-mobile-phone-payment">
  <div class="title">Betalingsmetode</div>
  <div class="payment-options">
    @if (!isMobilBytteBytte) {
      <app-ice-select-box
        label="Betal nå med abonnement"
        radioTestId="pay-now-with-subscription-input"
        type="radio"
        [control]="form.get(MobilePhoneFormControls.PaymentType)"
        [value]="MobilePaymentType.PayNowWithSubscription"
      >
        <div class="price" inlineHeaderContent>
          @if (
            form.get(MobilePhoneFormControls.PaymentType).value === MobilePaymentType.PayNowWithSubscription &&
            !!selectedSubscriptionBundleOption
          ) {
            {{ selectedSubscriptionBundleOption.priceInformation.price | priceFormat: PriceType.OneTime }}
          } @else if (!!mobilePhoneVariant && !isManualRegistration) {
            fra {{ mobilePhoneVariant?.priceFrom | priceFormat: PriceType.OneTime }}
          }
        </div>
        <div class="content">
          <app-mobile-upfront-voice-selector
            [allVoiceOfferings]="allVoiceOfferings()"
            [isManualRegistration]="isManualRegistration"
            [mobilePhoneVariant]="mobilePhoneVariant"
            (selectedNewOfferingChanged)="onSelectedNewOfferingChanged($event)"
          />
          @if (canSellHardwareWithLogistics) {
            <div class="klarna-calculator">
              <app-ice-alert type="info">
                Vipps, kort eller Klarna. Ønsker kunden delbetaling kan du beregne månedskostnader i
                <a
                  class="klarna-calculator-link"
                  data-testid="klarna-calculator-link"
                  href="https://x.klarnacdn.net/hpp/calculator/v1/index.html?country=no"
                  target="_blank"
                >
                  Klarna sin kalkulator
                  <mat-icon>open_in_new</mat-icon>
                </a>
              </app-ice-alert>
            </div>
          }
        </div>
        @if (!!vasProduct) {
          <div>
            <app-ice-pill class="vas-offering-information" type="neutral" [isInteractive]="false">
              {{ vasProduct?.productName }}
              <span>
                @if (vasProduct?.monthlyPrice?.price?.includingVAT > 0) {
                  <span>&ensp;+</span>
                }
                <span>{{ vasProduct?.monthlyPrice?.price | priceFormat: PriceType.Monthly : 'Inkludert' }}</span>
              </span>
            </app-ice-pill>
            <app-unique-selling-points [VASProductName]="vasProduct?.productName" />
          </div>
        }
      </app-ice-select-box>
    }
    @if (mobilePhoneVariant && !isMobilBytteBytte) {
      <app-ice-select-box
        label="Betal nå uten abonnement"
        radioTestId="pay-now-without-subsciption-input"
        type="radio"
        [control]="form.get(MobilePhoneFormControls.PaymentType)"
        [disabled]="!canSellCellPhoneWithoutSubscription"
        [value]="MobilePaymentType.PayNowWithoutSubscription"
      >
        <div class="price" inlineHeaderContent>
          @if (!!mobilePhoneVariant && !isManualRegistration) {
            {{ mobilePhoneVariant.priceInformation?.originalPrice | priceFormat: PriceType.OneTime }}
          }
        </div>
        @if (canSellHardwareWithLogistics) {
          <div class="klarna-calculator">
            <app-ice-alert type="info">
              Vipps, kort eller Klarna. Ønsker kunden delbetaling kan du beregne månedskostnader i
              <a
                class="klarna-calculator-link"
                data-testid="klarna-calculator-link"
                href="https://x.klarnacdn.net/hpp/calculator/v1/index.html?country=no"
                target="_blank"
              >
                Klarna sin kalkulator
                <mat-icon>open_in_new</mat-icon>
              </a>
            </app-ice-alert>
          </div>
        }
      </app-ice-select-box>
    }
    @if (isTerminalCompatibleWithMobilbytte2) {
      <app-ice-select-box
        *appAllowSettings="[DealerClaimType.EquipmentUpgrade]"
        radioTestId="equipment-upgrade-input"
        type="radio"
        [control]="form.get(MobilePhoneFormControls.PaymentType)"
        [disabled]="!hasPerformedAllowanceCheck()"
        [label]="mobilBytteLabel"
        [matTooltip]="mobilBytteDisabledReason"
        [readonly]="isMobilBytteReadonly"
        [value]="MobilePaymentType.EquipmentUpgrade"
      >
        @if (
          (!hasPerformedDetailedCreditCheck() || isMobilBytteAvailable) &&
          !allowanceCheckFailed &&
          !hasMobilBytteProductInCart
        ) {
          <div inlineHeaderContent>
            <span>fra {{ mobilePhoneVariant.bestMonthlyPriceWithMobilbytte | priceFormat: PriceType.Monthly }}</span>
          </div>
        }

        @switch (mobilBytteApproval()) {
          @case (EquipmentUpgradeApprovedState.NotApproved) {
            @if (!isMobilBytteBytte) {
              <div header>Kredittsjekk ikke godkjent for nye MobilBytte-avtaler</div>
            }
          }
          @case (EquipmentUpgradeApprovedState.Undetermined) {
            <div class="missing-creditcheck-text" header>Krever utvidet kredittsjekk</div>
          }
          @case (EquipmentUpgradeApprovedState.Approved) {
            @if (!isMobilBytteAvailable && customer()?.authorizeResult?.equipmentUpgrade.availableCredit > 0) {
              <div header>
                Kunden kan kun få MobilBytte-avtaler for telefoner som
                <br />
                koster inntil
                <span class="credit-check-info">
                  {{ customer()?.authorizeResult?.equipmentUpgrade.availableCredit | priceFormat: PriceType.OneTime }}
                </span>
              </div>
            }
          }
        }

        @if (!hasPerformedDetailedCreditCheck()) {
          <div class="extended-credit-check">
            @if (!displayExtendedCreditCheckForm) {
              <app-ice-button
                color="secondary"
                size="small"
                testId="extended-credit-check-button"
                (click)="onExtendedCreditCheckClicked()"
              >
                Ta utvidet kredittsjekk
              </app-ice-button>
            } @else {
              <app-extended-credit-check />
            }
            @if (isCustomerNameInvalid) {
              <app-ice-alert type="error">
                <div heading>Ugyldig tegn i navn</div>
                <div>
                  Ta kontakt med kundeservice for å få hjelp
                  <br />
                  til å oppdatere kundeinformasjonen.
                </div>
              </app-ice-alert>
            }
          </div>
        }
      </app-ice-select-box>
    }
    @if (canPerformMobilBytteBytte() && isEquipmentUpgradeEnabled && !isMobilBytteBytte && !hasTradeinInCart()) {
      <app-mobilbytte-bytte-info [isFullWidth]="true" [showIcon]="false" />
    }
  </div>
  @if (isMobilBytteSelected && isMobilBytteAvailable) {
    <div class="mobilbytte-offering-container">
      <div class="title">Nedbetalingstid</div>
      <div class="mobilbytte-offerings">
        @for (mobilBytteOffering of mobilBytteOfferings; track mobilBytteOffering.value) {
          <app-ice-select-box
            radioTestId="mobilbytte-offering-input"
            type="radio"
            [control]="form.get(MobilePhoneFormControls.MobilBytteOffering)"
            [disabled]="!mobilBytteOffering.isWithinAvailableCredit"
            [label]="mobilBytteOffering.label"
            [matTooltip]="mobilBytteOffering.isWithinAvailableCredit ? '' : 'Overstiger kundens tilgjengelige kreditt'"
            [value]="mobilBytteOffering.value"
          >
            <div inlineHeaderContent>
              @if (mobilBytteOffering.offering.isCampaign) {
                <span class="previous-price">
                  {{ mobilBytteOffering.offering.bestPriceBeforeCampaign | priceFormat: PriceType.Monthly }}
                </span>
              }
              <span>
                {{ mobilBytteOffering.offering.monthlyPrice | priceFormat: PriceType.Monthly }}
              </span>
            </div>
            <div>
              @if (mobilBytteOffering.canOrderMobilBytteBytte) {
                <div class="offering-info">
                  <span>
                    Totalt ved bytte etter {{ mobilBytteOffering.offering.minimumNumberOfMonthsBeforeUpgrade }} mnd
                  </span>
                  <span>
                    {{ mobilBytteOffering.offering.minimumTotalPrice | priceFormat: PriceType.OneTime }}
                  </span>
                </div>
              }
              <div class="offering-info">
                <span>Totalt etter {{ mobilBytteOffering.offering.agreementPeriodInMonths }} mnd</span>
                <span>
                  {{ mobilBytteOffering.offering.totalPriceAfterAgreementPeriod | priceFormat: PriceType.OneTime }}
                </span>
              </div>
              <app-mobilbytte-offering-selector
                [allVoiceOfferings]="allVoiceOfferings()"
                [allVoiceProducts]="allVoiceProducts"
                [availableSubscriptions]="mobilePhoneVariant.mobilbytteOfferings.availableSubscriptions"
                [existingProductsAvailableForEquipmentUpgrade]="existingProductsAvailableForEquipmentUpgrade"
                (equipmentUpgradeNewOfferingChanged)="onEquipmentUpgradeNewOfferingChanged($event)"
              />
            </div>
          </app-ice-select-box>
        }
      </div>
    </div>
  }
</section>
